import { useMemo } from 'react';
import { useGetBoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import { useBoundaryTerritoryDetailsSelector } from '../../../../store/boundaryTerritoryDetails/boundaryTerritoryDetails.selectors';
import { isDataLayersArtificialBoundaryTerritoryGroup } from '../../mapTools/dataLayersTool/dataLayersTool.helpers';

export const useBoundaryDetailsMarkersCount = (boundaryTerritoryGroupId: number, boundaryIds: number[]) => {
  const boundaryTerritoryDetails = useBoundaryTerritoryDetailsSelector();
  const { getBoundaryTerritoryGroupById } = useGetBoundaryTerritoryGroup();

  const relevantBoundaryDetails = boundaryTerritoryDetails.get(boundaryTerritoryGroupId);
  const boundaryTerritoryGroup = getBoundaryTerritoryGroupById(boundaryTerritoryGroupId);

  const markersCount = useMemo(() => {
    if (!relevantBoundaryDetails
      || (boundaryTerritoryGroup && isDataLayersArtificialBoundaryTerritoryGroup(boundaryTerritoryGroup)) // aritificial BTGs do not have counts guaranteed
    ) {
      return null;
    }

    let markersSum = 0;

    for (const boundaryId of boundaryIds) {
      if (relevantBoundaryDetails.counts[boundaryId] !== undefined) {
        markersSum += relevantBoundaryDetails.counts[boundaryId] ?? 0;
      }
    }

    return markersSum;
  }, [relevantBoundaryDetails, boundaryTerritoryGroup, boundaryIds]);

  return {
    markersCount,
  };
};
